import { render, staticRenderFns } from "./logo_header.vue?vue&type=template&id=5025d8cc&"
import script from "./logo_header.vue?vue&type=script&lang=js&"
export * from "./logo_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports